var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCircle3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M15.624 9.379q0 .69-.287 1.196a2.4 2.4 0 0 1-.78.827 3.5 3.5 0 0 1-1.093.472v.041q1.203.15 1.825.738.63.588.629 1.573 0 .875-.43 1.565-.424.69-1.313 1.087-.89.396-2.29.396a8.3 8.3 0 0 1-1.545-.136A6 6 0 0 1 9 16.734v-1.798q.642.33 1.347.5.705.164 1.312.164 1.135 0 1.586-.39.459-.396.458-1.108 0-.416-.212-.704-.212-.287-.738-.437-.52-.15-1.456-.15h-.759v-1.62h.772q.924 0 1.402-.171.486-.178.656-.479.178-.307.178-.697 0-.534-.328-.834-.329-.3-1.094-.301-.478 0-.875.123-.39.116-.704.287-.315.165-.554.321l-.977-1.456q.588-.423 1.374-.704Q11.18 7 12.274 7q1.545 0 2.448.622.902.622.902 1.757"
})));
export default SvgCircle3;